// extracted by mini-css-extract-plugin
module.exports = {"h5sdk":"thirdLogin_h5sdk_3wbqt","gameFrame":"thirdLogin_gameFrame_2Howr","mask":"thirdLogin_mask_1dneE"};